export const SERVICE_DARK_HERO_PATHS = [
  "/ai-automation",
  "/ai-visibility",
  "/lead-generation",
  "/seo",
  "/website-design",
] as const;

export const CLOSING_BAND_PATHS = [
  "/",
  "/services",
] as const;

/** Overview hubs: Odysseus CTA closing band + attached footer seam. */
export const CC_OVERVIEW_ATTACHED_LOGICAL_PATHS = [
  "/",
  "/services",
  "/projects",
  "/blog",
] as const;
